<h1>Exit Surveys</h1>

<ch-cancellations-statistics></ch-cancellations-statistics>

<div class="panel panel-default">
  <div class="panel-heading">
    <h3 class="panel-title">
      Filters
    </h3>
    <button id='exitSurveryClearFilters' type="button" (click)="clearFilters()" class="btn btn-default pull-right">
      Clear all
    </button>
  </div>
  <div class="panel-body">
    <div class="table-nav-menu" style="display: flex; flex-wrap: wrap; padding-bottom: 15px">
      <ch-select-picker [items]="exitSurveyVersions" (change)="versionChanged($event)"
        [value]="pageParams.exitSurveyVersion"></ch-select-picker>
      <ch-search-input (search)="emailChanged($event)" value="{{ pageParams.email }}"></ch-search-input>
      <div class="filter-datepicker">
        <span><strong>From</strong></span>
        <button *ngIf="pageParams.from" class="btn btn-default ml-1" (click)="fromChanged(null)">&#x2715;</button>
        <ch-datepicker (onChange)="fromChanged($event)" [date]="pageParams.from" [monthOnly]="true"></ch-datepicker>
      </div>
      <div class="filter-datepicker">
        <span><strong>Until</strong></span>
        <button *ngIf="pageParams.until" class="btn btn-default ml-1" (click)="untilChanged(null)">&#x2715;</button>
        <ch-datepicker (onChange)="untilChanged($event)" [date]="pageParams.until" [monthOnly]="true"></ch-datepicker>
      </div>
    </div>

    <ch-exit-survey-statistics [pageParams]="pageParams"></ch-exit-survey-statistics>

    <div class="card">
      <div class="card-header">
        Exit Surveys
      </div>
      <div class="card-block">
        <div class="loading-cont" *ngIf="loading">
          <div class="loading-spinner"></div>
        </div>
        <p class="no-items-found" *ngIf="!loading && items.length == 0">No items found.</p>
        <table class="table table-hover" *ngIf="!loading && items.length > 0">
          <thead>
            <tr>
              <th class="sortable">
                <span class="col-name">
                  Email
                  <ch-sortable column="EMAIL" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">
                  Cancelled At
                  <ch-sortable column="CANCELLATION_DATE" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th class="sortable">
                <span class="col-name">
                  Survey Version
                  <ch-sortable column="EXIT_SURVEY_VERSION" [pageParams]="pageParams" (sort)="onSort($event)"></ch-sortable>
                </span>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>
                <span>{{ item.email }}</span>
              </td>
              <td>
                <span>{{ item.cancelledAt | dateFormat }}</span>
              </td>
              <td>
                <span>{{ item.exitSurveyVersion }}</span>
              </td>
              <td class="col-md-1">
                <a class="btn btn-primary" routerLink="/admin/exit-survey/details" [queryParams]="{ id: item.id }">
                  Details
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <div class="page-bottom-container action-buttons">
        <ch-pagination-dropdown *ngIf="!loading" [totalItems]="totalItems" [pageNumber]="pageParams.pageNumber"
          [pageSize]="pageParams.pageSize" (pageChanged)="onPageChanged($event)"></ch-pagination-dropdown>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey-list/exit-survey-list.component.html